import React from "react";
import Modal from "react-modal";
import closeIcon from "assets/IconExitModal.svg?url";
import PropTypes from "prop-types";
import clsx from "clsx";
import _ from "lodash";
import { Box, Circle } from "@chakra-ui/react";

const sizeClassMap = {
	medium: "StandardModalV2--medium",
	content: "StandardModalV2--content", // no default sizing, sized by rendered content, except overflow is prevented
};

const StandardModalV2 = (props) => {
	const overlayClassName = clsx("StandardModalV2_overlay", props.overlayClassName);
	const contentRootClassName = clsx("StandardModalV2", props.rootClassName, sizeClassMap[props.size], props.bodyClass); // content root (react-modal)
	const innerContentClassName = clsx("StandardModalV2_innerContent", props.contentClassName); // inner content root (children)

	// don't override these react-modal props - TODO: make this configurable
	const reactModalProps = _.omit(props, ["className", "overlayClassName"]);

	return (
		<Modal
			isOpen={props.open}
			onRequestClose={props.keepOpen ? () => {} : props.close}
			className={contentRootClassName}
			overlayClassName={overlayClassName}
			ariaHideApp={false}
			{...reactModalProps}
		>
			<React.Fragment>
				<button
					data-testid="StandardModalCloseButton"
					onClick={props.close}
					className={props.keepOpen ? "StandardModalV2_closeIcon--disabled" : "StandardModalV2_closeIcon"}
				>
					<img src={closeIcon} alt="" />
				</button>
				{props.title && (
					<h2 className={props.description?.length > 0 ? "StandardModalV2_title_description" : "StandardModalV2_title"} title={props.title}>
						{props.title}
					</h2>
				)}
				{props.description?.length > 0 && <label className="StandardModalV2_description">{props.description}</label>}
				<div className={innerContentClassName}>{props.children}</div>
				<div className="StandardModalV2_actions">{props.actions}</div>
			</React.Fragment>
			{props.isLiveView && (
				// This is to be rendered only when p2p modal is opened
				// This indicates the readiness for live view
				// displays a small circle in bottom right corner
				<Box marginY={2} justifyContent={"flex-end"} display={"flex"}>
					<Circle backgroundColor={props.liveViewReady ? "#3D835D" : "#D69F00"} size={2} data-testid="live-view-status" />
				</Box>
			)}
		</Modal>
	);
};
export default StandardModalV2;
StandardModalV2.propTypes = {
	open: PropTypes.bool,
	keepOpen: PropTypes.bool,
	close: PropTypes.func.isRequired,
	size: PropTypes.oneOf(["medium", "content"]),
	title: PropTypes.string,
	children: PropTypes.node,
	actions: PropTypes.node,
	description: PropTypes.string,
	bodyClass: PropTypes.string,
	contentClassName: PropTypes.string,
};
